module.exports = __webpack_public_path__ + "img/agents.ef545015.png";